const progressChangedCallback = () => {
  const progressBars = document.querySelectorAll<HTMLElement>("progress-bar.progress-bar");

  progressBars.forEach((progressBar) => {
    const max = progressBar.getAttribute("aria-valuemax");
    const now = progressBar.getAttribute("aria-valuenow");

    if (!max || !now) return;

    if (Number(now) >= Number(max)) {
      progressBar.setAttribute("data-progress-complete", "true");
    } else {
      progressBar.removeAttribute("data-progress-complete");
    }
  });
};

const observeProgressBarChanges = () => {
  const body = document.body;
  if (!body || body.hasAttribute("data-progress-observer-bound")) return;
  const observer = new MutationObserver(() => {
    const bars = document.querySelectorAll("progress-bar.progress-bar");
    if (bars.length) progressChangedCallback();
  });
  observer.observe(body, { childList: true, subtree: true });
  body.setAttribute("data-progress-observer-bound", "true");
};

document.addEventListener("DOMContentLoaded", () => {
  progressChangedCallback();
  observeProgressBarChanges();

  document.addEventListener("cart:change", () => {
    setTimeout(progressChangedCallback, 500);
  });
});
